module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"div","properties":{},"children":[{"type":"text","value":"\n"},{"type":"element","tagName":"vocabularium","properties":{},"children":[]},{"type":"text","value":"\n"}]}],"data":{"quirksMode":false}},"frontmatter":{"title":"Vocabularium"}}},"pathContext":{"slug":"/vocabularium/","title":"Vocabularium"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/vocabularium.json
// module id = 1395
// module chunks = 52267211011875